import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as orderCallActions from 'app/actions/order_call_actions';
import PhoneInput from 'app/components/phone_input';
import Logo from 'assets/images/logo_bottom.png'

class OrderCallPopup extends React.Component {
  closeWindow(event) {
    event.preventDefault();
    this.props.orderCallActions.closeWindow();
  }

  submitForm(event) {
    event.preventDefault();
    this.props.orderCallActions.sendCallOrder();
  }

  onFormInputChange(attr, event) {
    event.preventDefault();
    this.props.orderCallActions.updateFormData({[attr]: event.target.value});
    this.props.orderCallActions.removeError(attr);
  }

  render() {
    const { formData, formErrors } = this.props.state;

    return (
      <React.Fragment>
        <div className={`popup-layer ${this.props.state.showWindow ? 'active' : ''}`} >
          <div className='popup-wrapper sm- form-popup'>
            <div className='base-width'>
              <div className='popup'>
                <div className='popup-header branded-'>
                  <img className="logo" src={Logo} />
                  <a className='close' onClick={this.closeWindow.bind(this)} href='#' />
                  <h2>
                    Заказать звонок
                  </h2>
                  <p>
                    Введите имя и телефон, после чего
                    менеджер компании "ARGUS" перезвонит
                    вам для консультации
                  </p>
                </div>
                <div className='popup-body'>
                  <div className="call-form">
                    <div className="form-input">
                      <input type="text" className={!!~formErrors.indexOf('name') ? 'error' : ''} value={formData.name} placeholder="Имя" onChange={this.onFormInputChange.bind(this, 'name')} />
                    </div>
                    <div className="form-input">
                      <PhoneInput className={!!~formErrors.indexOf('phone') ? 'error' : ''} value={formData.phone} placeholder="Телефон" onChange={this.onFormInputChange.bind(this, 'phone')}/>
                    </div>
                  </div>
                </div>
                <div className='popup-footer'>
                  <a className={`button button-red button-large`}
                     onClick={this.submitForm.bind(this)} href='#'>
                  <span>
                    Отправить
                  </span>
                  </a>
                </div>

              </div>
            </div>
            <div className='cover-all' onClick={this.closeWindow.bind(this)}></div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state: state.orderCall,
  }
};

const mapDispatch = (dispatch) => {
  return {
    orderCallActions: bindActionCreators(orderCallActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(OrderCallPopup);



// WEBPACK FOOTER //
// ./app/javascript/app/components/order_call_popup/index.jsx